import { routePaths } from "@/shared/config/routePaths";
import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const DeviceModelDetailsPage = lazy(() => import('./DeviceModelEditPage').then(m => ({ default: m.DeviceModelDetailsPage })));
const DeviceModelsPage = lazy(() => import('./DeviceModelsPage').then(m => ({ default: m.DeviceModelsPage })));
const AssociationPoliciesPage = lazy(() => import('./AssociationPoliciesPage').then(m => ({ default: m.AssociationPoliciesPage })));
const AssociationPolicyEditPage = lazy(() => import('./AssociationPolicyEditPage').then(m => ({ default: m.AssociationPolicyEditPage })));

export const virtualDevicesRouter: RouteObject = {
    path: routePaths.virtualDevices.base,
    children: [
        {
            path: routePaths.virtualDevices.deviceModels.relative,
            element: <DeviceModelsPage />
        },
        {
            path: routePaths.virtualDevices.deviceModelDetails.relative,
            element: <DeviceModelDetailsPage />
        },
        {
            path: routePaths.virtualDevices.associationPolicies.relative,
            element: <AssociationPoliciesPage />
        },
        {
            path: routePaths.virtualDevices.associationPolicyDetails.relative,
            element: <AssociationPolicyEditPage />
        },
    ]
}

